import { combineReducers } from 'redux';
import authReducer from '../Auth/authReducer';
import userProfileReducer from '../Dashboard/External/USER_PROFILE/userProfileReducer'
import changePasswordReducer from '../Dashboard/External/USER_PROFILE/ChangePasswordReducer'
import TenantDetails from '../Dashboard/External/USER_PROFILE/UpdateTenantReducer'
import alertReducer from '../Dashboard/Components/AlertReducer';


// Homepage reducers
import homePageContentReducer from '../Dashboard/External/Home/HomePageContentReducer'

// What's new content
import whatNewReducer from '../Dashboard/External/Whatsnew/WhatNewReducer';


// FAQ 
import FAQ_Question from '../Dashboard/External/FAQ/FAQReducer'
import FAQSearchReducer from '../Dashboard/External/Search/FAQSearchReducer';

// Demo catalgue
import DemoCatalgue from '../Dashboard/External/Demo_Catalgue/DemoCatalgueReducer'



// Reset Page Content
import ResetPageReducer from '../Dashboard/External/Reset/ResetPageReducer';

// Content Store
import Content from '../Dashboard/External/ContentStore/ContentStoreReducer'

import Ingest from '../Dashboard/External/Demo_Catalgue/DemoIngestionReducer'
import Reset from '../Dashboard/External/Demo_Catalgue/ResetReducer'

import LearningHubData from '../Dashboard/External/LearningHub/LearningHubGetDataReducer'
import LearningHubDetails from '../Dashboard/External/LearningHub/LearningHubGetDetailsReducer'
import QuizValidate from '../Dashboard/External/LearningHub/LearningHubQuizReducer'
import TCTrainingStatus from '../Dashboard/External/LearningHub/TCTrainingStatusReducer';


import GetTenant from '../Dashboard/External/TenentBooking/BookingsReducer';
import BookTenent from '../Dashboard/External/TenentBooking/TenentReducer';
import ReleaseTenent from '../Dashboard/External/TenentBooking/ReleaseTenentReducer';


// Search reducer 
import GenericSearchReducer from '../Dashboard/External/Search/GenericSearchReducer';
import NarrativeSearchReducer from '../Dashboard/External/Search/NarrativeSearchReducer';
import ContentSearchReducer from '../Dashboard/External/Search/ContentSearchReducer'



// Sales
import SalesPersonaHomereducer from '../Dashboard/External/SalesDemo/Reducers/SalesPersonaHomReducer';
import FetchExistingDemoSessionReducer from '../Dashboard/External/SalesDemo/Reducers/FetchExistingDemoSessionReducer';
import CreateDemoSessionReducer from '../Dashboard/External/SalesDemo/Reducers/CreateDemoSessionReducer';
import DeleteDemoSessionReducer from '../Dashboard/External/SalesDemo/Reducers/DeleteDemoSessionReducer';
import UpdateDemoSessionReducer from '../Dashboard/External/SalesDemo/Reducers/UpdateDemoSessionReducer';
import GetSalesWalkthroughReducer from '../Dashboard/External/SalesDemo/Reducers/GetSalesWalkthroughReducer';
import UpdateSalesWalkthroughReducer from '../Dashboard/External/SalesDemo/Reducers/UpdateSalesWalkthorughReducer';



// Analytics
import SEAnalyticsReducer from '../Dashboard/External/Analytics/SEAnalytics/Reducer/SEAnalyticsReducer';
import MangerAnalyticsReducer from '../Dashboard/External/Analytics/MangerAnalytics/Reducer/ManAnalyticsReducer'
import LeadershipAnalyticsReducer from '../Dashboard/External/Analytics/LeadershipAnalytics/Reducer/LeadershipAnalyticsReducer';
import GetAnalyticsFilterReducer from '../Dashboard/External/Analytics/Filter/GetAnalyticsFilterReducer';


// Disclaimer
import DisclaimerReducer from '../Dashboard/Components/Disclaimer/GetDisclaimer/GetPartnerDisclaimerReducer';
import UpdateDisclaimerStatusReducer from '../Dashboard/Components/Disclaimer/UpdateStatus/UpdateDisclaimerReducer';


// Yads
import yadsTenantScenarioReducer from '../Dashboard/External/Yads/GetTenantScenGroupActionReducer';
import yadsStatusReducer from '../Dashboard/External/Yads/GetPollingStatusReducer';
import yadsIngestionReducer from '../Dashboard/External/Yads/YadDemoIngestionReducer';
import yadsScheduleReducer from '../Dashboard/External/Yads/YadsScheduleReducer';
import yadsCancelScheduleReducer from '../Dashboard/External/Yads/YadsCancelScheduleReducer'
import yadsPatchTenantReducer from '../Dashboard/External/Yads/YadsPatchTenantReducer';
import yadsRescheduleReducer from '../Dashboard/External/Yads/YadsRescheduleReducer';
import yadsRecurringScheduleReducer from '../Dashboard/External/Yads/YadsRecurringScheduleReducer';
import yadsCancelRecurringScheduleReducer from '../Dashboard/External/Yads/YadsDeleteRecurringScheduleReducer';
import yadsEditRecurringReducer from '../Dashboard/External/Yads/YadsEditRecurringReducer';

import onboardTenantReducer from '../Dashboard/External/USER_PROFILE/OnboardTenantReducer';
import forgotPasswordReducer from '../Auth/ForgotPasswordReducer';
import changePasswordByUrlReducer from '../Auth/ChangePasswordByUrlReducer';



import YadsTenantDetails from '../Dashboard/External/Yads/UpdateTenantReducer.js'
import yadsCancelIngestionReducer from '../Dashboard/External/Yads/YadsCancelIngestionReducer';

// rootReducer.js
import deleteTenantReducer from '../Dashboard/External/USER_PROFILE/DeleteTenantReducer';

// Admin Users
import fetchUserModuleDetailsReducer from '../Dashboard/External/AdminUsers/Reducers/FetchUserModuleDetailsReducer';
import updatePendingRequestReducer from '../Dashboard/External/AdminUsers/Reducers/UpdatePendingRequestReducer';
import approvePendingRequestReducer from '../Dashboard/External/AdminUsers/Reducers/ApprovePendingRequestReducer';
import rejectPendingRequestReducer from '../Dashboard/External/AdminUsers/Reducers/RejectPendingRequestReducer';
import deleteUserReducer from '../Dashboard/External/AdminUsers/Reducers/DeleteUserReducer';
import updateUserReducer from '../Dashboard/External/AdminUsers/Reducers/UpdateUserReducer';
import createAccountReducer from '../Dashboard/External/AdminUsers/Reducers/CreateAccountReducer';
import createAdminAccountReducer from '../Dashboard/External/AdminUsers/Reducers/CreateAdminAccountReducer';
import resetAdminUserPasswordReducer from '../Dashboard/External/AdminUsers/Reducers/ResetAdminUserPasswordReducer';
import fetchPendingRequestCountReducer from '../Dashboard/External/AdminUsers/Reducers/FetchPendingRequestCountReducer';
import fetchAccountTypeMappingReducer from '../Dashboard/External/AdminUsers/Reducers/FetchAccountTypeMappingReducer';
import fetchAdminSharedTenantsReducer from '../Dashboard/External/AdminTenants/Reducers/FetchAdminSharedTenantsReducer';
import fetchAdminSharedTenantDetailReducer from '../Dashboard/External/AdminTenants/Reducers/FetchAdminSharedTenantDetailReducer';
import adminSharedTenantMutationsReducer from '../Dashboard/External/AdminTenants/Reducers/AdminSharedTenantMutationsReducer';
import adminAlertReducer from '../Dashboard/External/AdminAlerts/Reducers/AdminAlertReducer';
import emailMigrationReducer from '../Dashboard/External/EmailMigration/EmailMigrationReducer';



const rootReducer = combineReducers({
    auth: authReducer,



    // White Listed
    alert: alertReducer,
    profile: userProfileReducer,
    changePassword: changePasswordReducer,
    tenentDetails: TenantDetails,
    homePageContent: homePageContentReducer,
    whatNewReducer: whatNewReducer,
    FAQ_Question: FAQ_Question,
    Demo_Catalgue: DemoCatalgue,
    ResetPageContent: ResetPageReducer,
    Content: Content,
    LearningHubData: LearningHubData,
    LearningHubDetails: LearningHubDetails,
    TCTrainingStatus: TCTrainingStatus,


    // Black Listed
    Ingest: Ingest,
    QuizValidate: QuizValidate,
    Reset: Reset,
    GetTenant: GetTenant,
    BookTenent: BookTenent,
    ReleaseTenent: ReleaseTenent,


    // Search 
    GernicSearch: GenericSearchReducer,
    NarrativeSearch: NarrativeSearchReducer,

    ContentSearch: ContentSearchReducer,


    // Sales
    SalesPersonaHomepage: SalesPersonaHomereducer,
    ExistingDemoSession: FetchExistingDemoSessionReducer,
    NewSalesDemoSession: CreateDemoSessionReducer,
    DeleteDemoSession: DeleteDemoSessionReducer,
    UpdateDemoSession: UpdateDemoSessionReducer,
    GetSalesWalkthrough: GetSalesWalkthroughReducer,
    UpdateSalesWalkthrough:UpdateSalesWalkthroughReducer,

    // Analytics
    SEAnalytics: SEAnalyticsReducer,
    MangerAnalytics: MangerAnalyticsReducer,
    LeadershipAnalytics: LeadershipAnalyticsReducer,
  



    // Disclaimer
    getPartnerDisclaimer: DisclaimerReducer,
    updateStatus: UpdateDisclaimerStatusReducer,
    GetAnalyticsFilter:GetAnalyticsFilterReducer,

    FAQSearch :FAQSearchReducer,

    // Yads
    YadsTenantScenario: yadsTenantScenarioReducer,
    YadsStatus: yadsStatusReducer,
    YadsIngestion: yadsIngestionReducer,
    // rootReducer.js
    YadsSchedule: yadsScheduleReducer,
    YadsCancelSchedule: yadsCancelScheduleReducer,

    YadsPatchTenant: yadsPatchTenantReducer,
    YadsReschedule: yadsRescheduleReducer,
    YadsRecurringSchedule: yadsRecurringScheduleReducer,
    YadsCancelRecurringSchedule: yadsCancelRecurringScheduleReducer,
    YadsEditRecurring: yadsEditRecurringReducer,  

    OnboardTenant: onboardTenantReducer,
    
    ForgotPassword: forgotPasswordReducer,
    ChangePasswordByUrl: changePasswordByUrlReducer,

    yadstenentDetails: YadsTenantDetails,
    // 👇 NEW
    YadsCancelIngestion: yadsCancelIngestionReducer,

    DeleteTenant: deleteTenantReducer,

    // Admin Users
    AdminUserModuleDetails: fetchUserModuleDetailsReducer,
    AdminUpdatePendingRequest: updatePendingRequestReducer,
    AdminApprovePendingRequest: approvePendingRequestReducer,
    AdminRejectPendingRequest: rejectPendingRequestReducer,
    AdminDeleteUser: deleteUserReducer,
    AdminUpdateUser: updateUserReducer,
    AdminCreateAccount: createAccountReducer,
    AdminCreateUserAccount: createAdminAccountReducer,
    AdminResetUserPassword: resetAdminUserPasswordReducer,
    AdminPendingRequestCount: fetchPendingRequestCountReducer,
    AdminAccountTypeMapping: fetchAccountTypeMappingReducer,
    AdminSharedTenantsList: fetchAdminSharedTenantsReducer,
    AdminSharedTenantDetail: fetchAdminSharedTenantDetailReducer,
    AdminSharedTenantMutations: adminSharedTenantMutationsReducer,
    AdminAlert: adminAlertReducer,
    EmailMigration: emailMigrationReducer,
});

export default rootReducer;
